module.exports = __webpack_public_path__ + "img/cl_export_doc_1.34105908.png";